module.exports = __webpack_public_path__ + "static/media/beth.b1680bcc.png";